<template>
  <v-main>

    <v-container
        id="view-suspensions-container"
        fluid
        tag="section"
    >

      <base-material-card
          icon="mdi-text-box-outline"
          class="px-5 py-3"
      >

        <div data-cy="page-messages">
          <shared-page-messages :error-messages="errorMessages"
                                :warning-messages="warningMessages"
                                :success-messages="successMessages">
          </shared-page-messages>
        </div>



        <v-card-text>


          <div class="px-5 py-5" v-if="suspensions.length === 0">
            <p>You don't have any suspensions.</p>
          </div>


          <v-simple-table
              v-if="suspensions"
              fixed-header
          >
            <template v-slot:default>
              <thead>
              <tr>
                <th class="suspension-invoice-num text-subtitle-2">Invoice #</th>
                <th class="suspension-invoice-item text-subtitle-2">Replenishment/Description</th>
                <th class="suspension-amount text-subtitle-2 text-right">Balance</th>
                <th class="suspension-invoice-due-date text-subtitle-2">Due Date</th>
                <th class="suspension-start-date text-subtitle-2">Start Date</th>
                <th class="suspension-end-date text-subtitle-2">End Date</th>
                <th class="suspension-end-date text-subtitle-2 text-right">Days</th>
                <th class="suspension-active text-subtitle-2">Active</th>
              </tr>
              </thead>
              <tbody>
              <tr
                  v-for="suspension in suspensions"
                  :key="suspension.id"
              >
                <td>
                  <router-link :to="{ name: 'view_invoice', params: {id: suspension.invoice.id} }">
                    {{ suspension.invoice.id }}
                  </router-link>
                </td>
                <td>
                  {{ suspension.invoice.items[0].description }}
                </td>
                <td class="text-right">{{ suspension.invoice.balance | formatCurrency }}</td>
                <td>{{ suspension.invoice.dueDate | formatLocalDate }}</td>
                <td>{{ suspension.startDate | formatLocalDate }}</td>
                <td>{{ suspension.endDate | formatLocalDate }}</td>
                <td class="text-right">{{ suspension.period }}</td>
                <td>
                  <span v-if="suspension.isActive">
                    Yes
                  </span>
                  <span v-else>No</span>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>

        </v-card-text>

      </base-material-card>


    </v-container>

  </v-main>
</template>

<script>
import api from '@/services/api'
import {mapGetters} from "vuex";
import SharedPageMessages from '@/views/components/shared/PageMessages.vue'

export default {
  name: 'CoreViewSuspensionsView',
  components: {
    SharedPageMessages
  },

  async created() {
    this.$gtag.event('view_suspensions')

    this.userId = this.getUserId
    if (this.userId !== null) {
      await this.fetchSuspensions()
    }
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    })
  },

  methods: {
    async fetchSuspensions() {
      api.fetchSuspensions(this.userId)
          .then(response => {
            this.suspensions = response.data
          })
          .catch(err => {
            this.handleError(err)
          })
    },
    handleError(err) {
      let errorMessage = api.parseResponseError(err)
      this.errorMessages.push(errorMessage)
    }
  },

  data() {
    return {
      errorMessages: [],
      successMessages: [],
      warningMessages: [],
      userId: null,
      user: {
        country: 'US',
        idType: {}
      },
      suspensions: []
    }
  }
}
</script>

<style lang="sass">
th.suspension-invoice-num
  width: 10%
th.suspension-amount, th.suspension-active, th.suspension-balance
  width: 5%

th.suspension-num, th.suspension-date, th.due-date, th.suspension-amount, th.suspension-status
  width: 12%

</style>
